import React, {FC, useEffect, useState} from 'react';
import {Loader, ShowMoreText} from '../../../Components';
import {Button, Flex, Link, Text} from '@priority-software/priority-style-react';
import texts from '../../../texts';
import ReportImage from '../../../../../images/EOY-Report-image.svg';
import styles from './JournalEntriesCheckStep.module.scss';
import {observer} from 'mobx-react';
import {journalEntriesCheckProc} from '../../../actions/journalEntriesCheck';
import {NextState} from '../../../types';
import {useFooterContext} from '../../../hooks';
import {isRTL} from '../../../../../Localization';
import classNames from 'classnames';
import {apploadAttachmentsToLog} from '../../../actions/wizardLog';
import {reportIdByReportName} from '../../../constants';
import {useFiscalYear} from '../../../hooks/useFiscalYear';
import {startEntity} from '../../../../../_shared/GWTBridge/invoke/genPage';

export const JournalEntriesCheckStep: FC = observer(() => {
    const [checkLoading, setCheckLoading] = useState(false);
    const [fiscalYearStateLoaded, fiscalYearState] = useFiscalYear();
    const [url, setUrl] = useState<string>();
    const footerState = useFooterContext();
    const isRtl = isRTL();

    useEffect(() => {
        footerState.setIsValid(false);
    }, []);

    useEffect(() => {
        if (footerState.onNextState === NextState.Processing) {
            footerState.setOnNextState(NextState.Done);
        }
    }, [footerState.onNextState]);

    const onCheckButtonClick = () => {
        setCheckLoading(true);
        journalEntriesCheckProc().then(url => {
            setUrl(url);
            apploadAttachmentsToLog(
                url,
                fiscalYearState.exttype,
                fiscalYearState.nscust,
                reportIdByReportName['CHKFNCTRANS']
            );
            footerState.setIsValid(true);
            setCheckLoading(false);
        });
    };

    return (
        <Flex
            componentClasses={classNames(styles.wrapper, {
                [styles.wrapperRtl]: isRtl
            })}
            direction={'column'}
        >
            <ShowMoreText
                text={texts['stage0_step3_explanation']}
                extendedText={texts['stage0_step3_more_text']}
            />
            <Flex componentClasses={styles.buttons}>
                <Button
                    componentClasses={styles.button}
                    onClick={() => onCheckButtonClick()}
                    wideButton
                    size={'medium'}
                    disabled={checkLoading || !fiscalYearStateLoaded}
                >
                    {texts['stage0_step3_title']}
                </Button>
            </Flex>
            <Loader
                isVisible={checkLoading}
                componentClassname={styles.loader}
                workingLabel={texts['working_on_it']}
            />
            {url !== undefined && (
                <Flex direction={'column'} componentClasses={styles.info}>
                    <div className={styles.image}>
                        <img src={ReportImage} alt={''} />
                    </div>
                    <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-700'}>
                        {texts['stage_0_step3_links']}
                        <Link target={'_blank'} href={url} componentClasses={styles.link}>
                            <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-500'}>
                                {texts['stage_0_step3_link_name']}
                            </Text>
                        </Link>
                        {texts['stage0_step2_branches_notice_ending']}
                    </Text>
                    <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-700'}>
                        {texts['stage_0_step3_links2']}
                        <Link
                            componentClasses={styles.link}
                            onClick={() =>
                                startEntity(
                                    'EOYLOG',
                                    'GLNAME',
                                    fiscalYearState.year.toString(),
                                    'EXTFILES'
                                )
                            }
                        >
                            <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-500'}>
                                {texts['stage_0_step3_link2_name']}
                            </Text>
                        </Link>
                        {texts['stage0_step2_branches_notice_ending']}
                    </Text>
                </Flex>
            )}
        </Flex>
    );
});
